import {  Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { first } from 'rxjs';
import { LayoutService } from 'src/app/service/layout.service';
import { Code } from '../../page/company/os/popups/add-breakdowns/damages/enums/code';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-vehicle-breakpoint-part-name',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatInput,
    MatLabel,
    MatRadioGroup,
    MatError,
    MatRadioButton,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './vehicle-breakpoint-part-name.component.html',
  styleUrl: './vehicle-breakpoint-part-name.component.scss'
})
export class VehicleBreakpointPartNameComponent implements OnInit {

  formController = new FormGroup({
    vehiclePartName: new FormControl<string>(''),
    code: new FormControl<Code>(undefined, [Validators.required]),
  })

  isMobile: boolean;
  availableCodes: { key: string, value: string }[];

  constructor(
    private _dialogRef: MatDialogRef<VehicleBreakpointPartNameComponent>,
    private _layoutService: LayoutService,
  ) { }

  ngOnInit(): void {
    this._layoutService.isHandset$.pipe(first()).subscribe(isMobile => this.isMobile = isMobile)
    this.availableCodes = Array.from(Object.entries(Code), ([key, value]) => ({ key, value }))
  }

  confirm(){
    const { vehiclePartName, code } = this.formController.value;
    this._dialogRef.close({ vehiclePartName, code });
  }

  cancel(){
    this._dialogRef.close();
  }
}
